//Style
import styles from "../../../../styles/Form-Inputs.module.css"

//primereact
import { MultiSelect } from "primereact/multiselect"
import { Skeleton } from "primereact/skeleton"

//Formik
import { useField } from "formik"

export default function RefMultiSelect({
  name,
  label,
  isInitialLoad,
  options,
  optionLabel,
  placeHolderValue,
  helpText,
  itemTemplate,
  disabled,
}) {
  const [field, meta, helpers] = useField(name)

  const getSelect = () => {
    if (isInitialLoad) {
      return (
        <Skeleton
          className={meta.touched && meta.error ? "p-invalid block" : "block"}
          height="42px"
        />
      )
    } else {
      return (
        <>
          <MultiSelect
            value={field.value}
            options={options}
            onChange={(e) => helpers.setValue(e.value)}
            optionLabel={optionLabel}
            placeholder={
              !placeHolderValue ? `Please select an entry` : placeHolderValue
            }
            display="chip"
            filter
            className={meta.touched && meta.error ? "p-invalid" : undefined}
            itemTemplate={!!itemTemplate ? itemTemplate : null}
            disabled={disabled}
          />
          {meta.touched && meta.error ? (
            <label id={`${name}-error`} className={styles.errFieldMsg}>
              {meta.error}
            </label>
          ) : null}
        </>
      )
    }
  }

  return (
    <div className={styles.field}>
      <label>{label}</label>
      {helpText ? (
        <div>
          <small style={{ color: "gray" }}>{helpText}</small>
        </div>
      ) : null}
      <div>{getSelect()}</div>
    </div>
  )
}
